module.exports = {
  publicPath: '/produkte/fahrradversicherung/bot'
}
